export default {
  tenant: 'לקוח',
  tenants: 'לקוחות',
  tenantsOf: 'לקוחות {{type}}',
  'tenant.name': 'שם לקוח',
  'tenant.description': 'מידע נוסף על הלקוח או הפרויקט',
  'tenant.verification': 'רמת אימות KYB',
  'tenant.kyb.basic': 'בסיסי (אימייל בלבד)',
  'tenant.kyb.standard': 'סטנדרטי (אימייל + טלפון)',
  'tenant.kyb.premium': 'פרימיום (אימות מלא)',
  'tenant.list.title': 'ניהול לקוחות',
  'tenant.list.subtitle': 'נהל את לקוחות האפליקציה ביעילות.',
  'tenant.list.search.placeholder': 'חפש לקוחות לפי שם או תיאור',
  'tenant.info': 'פרטי לקוח',
  'tenant.form.title': 'כותרת לקוח',
  'tenant.form.description': 'תיאור לקוח',
  'tenant.form.assignments': 'הקצאות',
  'tenant.info.helper': 'ספק כותרת ברורה, תיאור תמציתי וסוג מתאים להגדרת הלקוח',
  'tenant.api': 'הגדרות API',
  'tenant.api.helper': 'הגדר את הגדרות ה־API עבור הלקוח',
  'tenant.api.origins': 'Origin מורשים (CORS)',
  'tenant.api.origins.helper':
    'Origin מלאים המורשים לשלוח בקשות API. פורמט: http(s)://host[:port] — לדוגמה https://example.com, http://localhost:5173, https://*.example.com. השאר ריק כדי לאפשר הכל. השתמש ב־"*" כדי לאפשר כל origin (לא מומלץ).',
  'tenant.api.origins.wildcard.warning':
    'אזהרה: "*" מאפשר בקשות מכל origin. זה מכבה את הגנת ה־CORS ללקוח זה — השתמש רק לנתונים ציבוריים ולא רגישים.',
  'tenant.api.origins.invalid':
    'Origin לא חוקיים: {{values}}. כל ערך חייב להיות "*" או להתחיל ב־http:// או https:// ולכלול host (ו־port אופציונלי).',
  'tenant.api.limit': 'מגבלת בקשות חודשית',
  'tenant.api.expiration': 'תאריך פקיעת מפתח API',
  'tenant.api.active': 'מפתח פעיל',
  'tenant.api.active.on': 'פעיל',
  'tenant.api.active.off': 'לא פעיל',
  'tenant.api.token.info': 'צור טוקן גרעיני בהיקף {name} לשימוש API אישי',
  'tenant.api.token.helper': 'הטוקן יפוג בתאריך שנבחר',
  'tenant.api.name.helper':
    'שם ייחודי ללקוח זה. עשוי להיות גלוי לבעלי המשאבים או למשתמשים שברשותם הטוקן.',
  'tenant.api.subscriptions.available': 'מנויים זמינים',
  'tenant.api.subscriptions.available.placeholder':
    'בחר מנויים הזמינים ללקוח זה',
  'tenant.api.generateKey': 'צור מפתח API חדש',
  'tenant.api.handleKey': 'נהל מפתח API',
  'tenant.api.keyCreated': 'מפתח API נוצר בהצלחה',
  'tenant.api.keyCopied': 'מפתח API הועתק ללוח',
  'tenant.api.keys.title': 'מפתחות API',
  'tenant.api.keys.delete.confirm': 'האם אתה בטוח שברצונך למחוק מפתח API זה?',
  'tenant.api.keys.activate.confirm':
    'האם אתה בטוח שברצונך להפעיל מפתח API זה?',
  'tenant.api.keys.deactivate.confirm':
    'האם אתה בטוח שברצונך להשבית מפתח API זה?',
  'tenant.api.keys.delete.success': 'מפתח API נמחק בהצלחה',
  'tenant.api.keys.deactivate.success': 'מפתח API הושבת בהצלחה',
  'tenant.api.keys.noKeys': 'לא נמצאו מפתחות API',
  'tenant.api.keys.usageCount': 'כמות שימוש',
  'tenant.api.keys.info.attention': 'שים לב!',
  'tenant.api.keys.info.attention.alert':
    'אל תשתף מפתח זה עם צדדים שלישיים. אם המפתח נפגע, בטל אותו מיד בפאנל הניהול.',
  'tenant.api.keys.info.attention.helper':
    'אנא שמור את מפתח ה־API הזה. הוא לא יוצג שוב במערכת.',
};
